// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"462":"a2fcde9f","3216":"9b93c0b8","3613":"20594a2d","5121":"a2fcde9f","5482":"a2fcde9f","5832":"a2fcde9f","7283":"20594a2d"}[chunkId] + ".chunk.css";
};